import { Inject, Injectable, OnDestroy } from '@angular/core';
import 'pusher-js';
import { Subject, Subscription } from 'rxjs';
import { AppConfigService } from '../app-config/app-config.service';
import { Settings } from './models';
import { APP_SETTINGS } from './settings-data.provider';

const Pusher = (window as any).Pusher;

interface Pusher {
  subscribe: (channel: string) => Channel;
  unsubscribe: (channel: string) => void;
}

interface Channel {
  bind: (message: string, callback: (data: any) => void) => void;
}

interface ScanData {
  code: string;
}

@Injectable({providedIn: 'root'})
export class PusherService implements OnDestroy {
  private subscription: Subscription | null = null;
  private _scan = new Subject<string>();
  private _reservation = new Subject<void>();
  private _pickup = new Subject<void>();
  private _pusher: Pusher | null = null;
  private channelName: string = '';

  scan = this._scan.asObservable();
  reservation = this._reservation.asObservable();
  pickup = this._pickup.asObservable();

  constructor(private readonly appConfigService: AppConfigService, @Inject(APP_SETTINGS) private readonly settings: Settings) {
    this.subscription = this.appConfigService.configChange.subscribe(appConfig => this.setupPusher(appConfig?.pusherApiKey));
  }

  private cleanupPusher() {
    this._pusher?.unsubscribe(this.channelName);
    this._pusher = null;
    this.channelName = '';
  }

  private setupPusher(apiKey?: string) {
    this.cleanupPusher();

    if (!apiKey) {
      return;
    }

    this.channelName = this.settings.posUuid;
    this._pusher = new Pusher(apiKey, {
      wsHost: 'ws-eu.pusher.com',
      httpHost: 'sockjs-eu.pusher.com',
      encrypted: true
    });

    const channel = this._pusher!.subscribe(this.channelName);

    channel.bind('scan', (scanData: ScanData) => {
      this._scan.next(scanData.code);
    });

    channel.bind('reservation', () => this._reservation.next());
    channel.bind('pickup', () => this._pickup.next());
  }

  ngOnDestroy(): void {
    this.cleanupPusher();
    this._scan.complete();
    this._reservation.complete();
    this._pickup.complete();
    this.subscription?.unsubscribe();
  }
}
